
import { WorkflowStep } from '../../types';

export const checkDependencies = (stepId: number, steps: WorkflowStep[]): boolean => {
  const step = steps.find(s => s.id === stepId);
  if (!step?.dependencies) return true;
  
  return step.dependencies.every(depId => {
    const depStep = steps.find(s => s.id === depId);
    return depStep?.status === 'completed';
  });
};

export const getPreviousResults = (stepId: number, steps: WorkflowStep[]): string | null => {
  const step = steps.find(s => s.id === stepId);
  if (!step?.dependencies) return null;

  const previousResults: string[] = [];
  
  step.dependencies.forEach(depId => {
    const depStep = steps.find(s => s.id === depId);
    if (depStep?.result) {
      let sectionTitle = '';
      switch (depId) {
        case 1:
          sectionTitle = 'POLITICAL CONTEXT RESEARCH';
          break;
        case 2:
          sectionTitle = 'POLITICAL CONTEXT REFINEMENT';
          break;
        case 3:
          sectionTitle = 'WINNING ASPIRATION ANALYSIS';
          break;
        case 4:
          sectionTitle = 'DECISION MAKERS ANALYSIS';
          break;
        case 5:
          sectionTitle = 'CONSTITUENCIES & STAKEHOLDERS ANALYSIS';
          break;
        case 6:
          sectionTitle = 'MESSAGE FRAME ANALYSIS';
          break;
        case 7:
          sectionTitle = 'OPPOSITION RESEARCH & COUNTER-STRATEGY';
          break;
        case 8:
          sectionTitle = 'CHANNELS & PLATFORMS STRATEGY';
          break;
        case 9:
          sectionTitle = 'THEORY OF CHANGE ANALYSIS';
          break;
        case 10:
          sectionTitle = 'MESSAGE DEVELOPMENT GUIDE';
          break;
        case 11:
          sectionTitle = 'CORE CAPABILITIES ASSESSMENT';
          break;
        case 12:
          sectionTitle = 'CAMPAIGN PLAN & MANAGEMENT SYSTEMS';
          break;
      }
      
      previousResults.push(`${sectionTitle}:\n${depStep.result}`);
    }
  });

  const combinedResults = previousResults.join('\n\n---\n\n');
  
  console.log(`getPreviousResults for step ${stepId}: Found ${previousResults.length} previous results`);
  
  return combinedResults || null;
};

export const findNextValidStep = (currentStep: number, steps: WorkflowStep[]): number => {
  let nextStep = currentStep + 1;
  while (nextStep <= steps.length && !checkDependencies(nextStep, steps)) {
    nextStep++;
  }
  return nextStep;
};
